import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";
import { Monogram } from "./Monogram";
import { CONTACT, NAV_LINKS } from "../data/site";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-[#202023] bg-[#0F0F11]">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3">
          <Monogram size="md" />
          <div>
            <p className="font-display text-2xl font-semibold text-white">SHUTEN</p>
            <p className="font-mono2 text-[10px] uppercase tracking-[0.35em] text-zinc-500">Tattoo Studio · Budapest</p>
          </div>
        </div>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-zinc-400">
          Sötét, japán-ázsiai hangulatú tetováló és piercing stúdió Budapest szívében. Nyolc művész, egy ház.
        </p>
      </div>

      <div>
        <p className="eyebrow mb-5">Oldalak</p>
        <ul className="space-y-2.5">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase()}`} className="text-sm text-zinc-400 transition-colors hover:text-[#C04B58]">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="eyebrow mb-5">Kapcsolat</p>
        <ul className="space-y-3 text-sm text-zinc-400">
          <li className="flex items-start gap-2.5">
            <MapPin size={15} className="mt-0.5 shrink-0 text-[#9A3542]" /> {CONTACT.address}
          </li>
          <li className="flex items-center gap-2.5">
            <Phone size={15} className="shrink-0 text-[#9A3542]" />
            <a href={CONTACT.phoneHref} className="transition-colors hover:text-white">{CONTACT.phone}</a>
          </li>
          <li className="flex items-center gap-2.5">
            <Mail size={15} className="shrink-0 text-[#9A3542]" />
            <a href={`mailto:${CONTACT.email}`} className="transition-colors hover:text-white">{CONTACT.email}</a>
          </li>
        </ul>
        <div className="mt-5 flex gap-3">
          <a
            href={CONTACT.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram"
            aria-label="Instagram"
            className="rounded-full border border-white/10 p-2.5 text-zinc-400 transition-all hover:border-[#9A3542] hover:text-[#C04B58]"
          >
            <Instagram size={17} />
          </a>
          <a
            href={CONTACT.facebook}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-facebook"
            aria-label="Facebook"
            className="rounded-full border border-white/10 p-2.5 text-zinc-400 transition-all hover:border-[#9A3542] hover:text-[#C04B58]"
          >
            <Facebook size={17} />
          </a>
        </div>
      </div>
    </div>
    <div className="border-t border-[#202023] py-6 text-center font-mono2 text-[11px] uppercase tracking-[0.25em] text-zinc-600">
      © 2026 Shuten Tattoo Studio Budapest
    </div>
  </footer>
);
